import { useState } from "react";
import attachments from "../../assets/images/AttachmentsImg/IMG_7776.png";
import QUALITY from "../../assets/images/Tuatara 1000 - Cabin View.jpg";
import ADAPTABILITY from "../../assets/images/Kiwi Fruit farm.jpg";
import SUSTAINABILITY from "../../assets/images/eTuatara1 (Craig).jpg";

const Values = () => {
  const [activeTab, setActiveTab] = useState(0);
  const infoArray = ["DURABILITY", "QUALITY", "ADAPTABILITY", "SUSTAINABILITY"];
  const List = [
    {
      img: attachments,
      dec: "Durability is at the core of our design, with steel-constructed utility vehicles engineered to tackle the tough terrains and jobs.",
    },
    {
      img: QUALITY,
      dec: "We believe in quality that you can rely on, delivering top-tier performance and longevity in every model.",
    },
    {
      img: ADAPTABILITY,
      dec: "Our vehicles are also adaptable, offering versatile features to meet the needs of diverse industries, from agriculture to adventure tourism.",
    },
    {
      img: SUSTAINABILITY,
      dec: "Finally, we are committed to sustainability, with innovative electric models that support a greener future without compromising power or efficiency.",
    },
  ];
  return (
    <>
      <div className="bg-[#7ABF5B]">
        <div className="custom-container py-[50px]">
          <div className="2xl:text-[46px] xl:text-[40px] lg:text-[35px] md:text-[28px] text-[23px] text-[#000] font-[Rockwell] font-bold border-b-[3px] border-[#fff]">
            VALUES
          </div>

          <div className="flex flex-wrap">
            {infoArray.map((item, index) => {
              return (
                <div
                  onClick={() => setActiveTab(index)}
                  className={`${activeTab == index ? "text-[#292929]" : "text-[#fff]"
                    } cursor-pointer lg:mr-[60px] md:mr-[40px] mr-[10px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] lg:mt-[40px] md:mt-[30px] sm:mt-[20px] mt-[10px] font-bold`}
                >
                  <span
                    className={`${activeTab == index
                      ? "underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#292929] lg:pb-[16px] md:pb-[6px] pb-[0px]"
                      : ""
                      }`}
                  >
                    {item}
                  </span>
                </div>
              );
            })}
          </div>
          <div className="lg:mt-[60px] md:mt-[50px] sm:mt-[30px] mt-[20px]">
            <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
              {List[activeTab]?.dec}
            </div>
          </div>
        </div>

        <div >
          <img
            key={activeTab}
            src={List[activeTab]?.img}
            alt={infoArray[activeTab]}
            className="w-full lg:h-[763px] md:h-[663px] sm:h-[463px] h-[263px] object-center object-contain transition-opacity duration-300"
          />
        </div>
      </div>
    </>
  );
};
export default Values;
